// plugins/canonical.ts
export const windowLocationOrigin = typeof window !== "undefined" 
  ? window.location.origin 
  : 'https://www.divissa.com.tr';

const backendUrl = typeof window !== "undefined"
  ? window.location.origin
  : 'https://www.divissa.com.tr';

export default defineNuxtPlugin((nuxtApp) => {
  updateCanonical();
  nuxtApp.hook("page:finish", () => {
    updateCanonical();
  });

  function updateCanonical() {
    const route = useRoute();
    const currentUrl = `${backendUrl}/${route.path.replace(/^\//, '')}`;
    const headConfig: any = {
      link: [
        {
          rel: "canonical",
          href: currentUrl,
          key: "canonical-" + route.path,
        },
      ],
      meta: [],
    };
 
   

    useHead(headConfig);
  }
});